module.exports = __webpack_public_path__ + "static/media/voucherEMD.d1037395.svg";